<div class="row">
    <div class="col-12 px-xl-5 grillaMovies">
        <div class="row">
            <div class="col-12 my-4">
                <!-- Diferentes lables -->
                <div *ngIf="currentTagType == tag_type.actor">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por actor: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.anio">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por año: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.director">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por dirección: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.pais">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por pais: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.tema">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por tema: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.idioma">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por idioma: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.categorias">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por categoria: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.genero">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por genero: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.production">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por producción: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.script">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por guión: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.photography">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por dirección de fotografía: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.sound">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por dirección de sonido: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.music">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por música: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.edition">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por edición: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.artDirection">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por dirección de arte: '{{ labelInput }}'
                    </h1>
                </div>
                <div *ngIf="currentTagType == tag_type.productionCompany">
                    <h1 class="text-white font-weight-bolder mb-0" *ngIf="labelInput">
                        Busqueda por casa productora: '{{ labelInput }}'
                    </h1>
                </div>
                <p class="lead text-muted mb-0 animate__animated animate__fadeIn animate__faster" *ngIf="!loading">
                    {{ movies.length }} resultados encontrados
                </p>

                <div class="roller-container">
                    <div class="rollerLoader">
                        <div class="spinner-border mt-2" style="width: 3rem; height: 3rem" role="status"
                            *ngIf="loading">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row grilla animate__animated animate__fadeIn" *ngIf="movies.length > 0 && !loading">
            <div class="col col-12 col-md-6 col-lg-4 col-xl-3 " *ngFor="let movie of movies">
                <div class="card">
                    <app-movie-item class="movie-item" [movie]="movie"></app-movie-item>
                </div>
            </div>
        </div>

        <div class="row p-lg-5" *ngIf="movies.length == 0 && !loading">
            <div class="sinResultado p-lg-5">
                <div class="icono">
                    <i class="fas fa-heart-broken"></i>
                </div>
                <p class="text-muted">
                    No pudimos encontrar resultados
                </p>
            </div>
        </div>
    </div>
</div>